export const useDocumentTitle = (title: string) => {
  document.title = title;
};
